(function navbarToggler() {
    let $collapsingNavbar;
    let $navBackground;

    $(document).ready(() => {
        $collapsingNavbar = $('#collapsingNavbar');
        $navBackground = $('.navbar-collapse-background');

        calcDropdownHeight();

        $(window).on('resize', () => {
            calcDropdownHeight();

            if (window.innerWidth > 1199.98) {
                closeNavbar(); // On bigger screens hamburger menu in not needed.
            }
        });

        // Hide auth section on hamburger menu show.
        $('.navbar-toggler').on('click', () => {
            if ($collapsingNavbar.hasClass('collapsing-nav') || $collapsingNavbar.hasClass('expanding-nav')) { return; }

            if ($collapsingNavbar.hasClass('collapsed-nav')) {
                openNavbar();
            } else if ($collapsingNavbar.hasClass('expanded-nav')) {
                closeNavbar();
            }
        });

        $collapsingNavbar.on('transitionend', (e) => {
            if (e.originalEvent.propertyName !== "transform") { return; } // There are many transitions on the navbar, limit to only opening and closing tranformations.

            if ($collapsingNavbar.hasClass('collapsing-nav')) {
                $collapsingNavbar.removeClass('collapsing-nav').addClass('collapsed-nav');
                $navBackground.css('height', ''); // After background animations finish, remove the set height.
            } else if ($collapsingNavbar.hasClass('expanding-nav')) {
                $collapsingNavbar.removeClass('expanding-nav').addClass('expanded-nav');
            }
        });
    });

    function openNavbar() {

        $('#authSection').removeClass('expand-auth-section'); // Close the auth section if opened.

        if ($collapsingNavbar.hasClass('expanding-nav')) { return; }

        // For some reason removing the collapsed-nav class (therefore removing display:none style) without wrapping it in requestAnimationFrame, does not work on tested tablet device,
        // it works as intended on other tested media. 
        requestAnimationFrame(() => {
            $collapsingNavbar.removeClass('collapsed-nav');

            // Wait until next browser repaint to add expanding class, this is needed as animations cannot start if element has display:none style.
            requestAnimationFrame(() => {
                $collapsingNavbar.addClass('expanding-nav');
                $navBackground.addClass('show');
            });
        });

    }

    function closeNavbar() {
        if ($collapsingNavbar.hasClass('collapsing-nav') || $collapsingNavbar.hasClass('collapsed-nav')) { return; }

        $collapsingNavbar.addClass('collapsing-nav').removeClass('expanded-nav');
        $navBackground.removeClass('show').css('height', '100%'); // Start removing the background, set it height to allow opacity animations to finish.
    }

    /**
     * Fixes mobile dropdown problem where disappearing browser nav prevents scrolling to login button.    
     */
    function calcDropdownHeight() {
        $collapsingNavbar.css('max-height', window.innerHeight - parseInt($('#collapsingNavbar').css('top'), 10));
    }
})();